import Vue from 'vue';
import VueRouter from 'vue-router';

import { utils } from "./utils";

Vue.use(VueRouter);

// 根据不同的环境加载不同的路由
const routes = []
if (utils.Browser.mobile) {
    routes.push(
        {
            path: '',
            name: 'mobile',
            component: () => import('./mobile'),
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('./mobile/news'),
        },
        {
            path: '/news/detail/:id',
            name: 'detail',
            component: () => import('./mobile/news/detail'),
        },
        {
            path: '*', redirect: '/'
        }
    )

} else {
    routes.push(
        {
            path: '',
            name: 'pc',
            component: () => import('./pc?v=2'),
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./pc/about'),
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('./pc/news'),
        },
        {
            path: '/news/detail/:id',
            name: 'detail',
            component: () => import('./pc/news/detail'),
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./privacy'),
        },
        {
            path: '*', redirect: '/'
        }
    )
}

// IOS下载安装页面
// routes.push({
//     path: '/install2',
//     name: 'install2',
//     component: () => import('./install/index2'),
// })

// IOS下载安装页面
routes.push({
    path: '/install',
    name: 'install',
    component: () => import('./install'),
    meta: {
        // title:'安装游好赚',
        keepAlive: false
    }

})

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    scrollBehavior() { // vue跳转页面是在底部，而不是在顶部，所以加下面的 这个配置
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})

export {
    router
};
